import React, { useState, Fragment } from 'react';
import { Card, Col, Container, Form, Row, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaSearch } from "react-icons/fa";
import { serviceGetDocumento } from '../../../api/api-aprobacion-objecion';
import { formatoMonto } from '../../../common/Formatos';
import { LoadingComponent } from 'recupero-comunes'


const HeaderInfo = ({ cfg_form, implicado, idCaso, idOrgCaso }) => {
    const [loading, setLoading] = useState(false);

    const handleInforme = async () => {
        if (implicado?.idfolioCargaDocto) {
            setLoading(true);
            let query = Buffer.from(JSON.stringify({
                idCaso: idCaso,
                idImplicadoCaso: implicado?.IdImplicado,
                idCompania: idOrgCaso,
                idfolioCarga: implicado?.idfolioCargaDocto
            })).toString('base64')

            const response = await serviceGetDocumento(query);
            setLoading(false);

            var link = document.createElement("a");
            link.download = response.filename;
            link.href = "data:" + response.mimetype + ";base64," + response.file;
            link.click();
        }
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Card>
                <Card.Header as='h6' style={{ backgroundColor: "rgb(209, 242, 235)", color: 'color: rgb(255, 255, 255)' }}>
                    {cfg_form && cfg_form["legalizapagotercero-subtitle1"]}
                </Card.Header>

                <Card.Body>
                    <Container>
                        <Row>
                            <Col md='3' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["legalizapagotercero-lbl-compania"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {implicado && implicado.CiaImplicado}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["legalizapagotercero-lbl-sinitercero"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {implicado && implicado.SiniestroIM}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["legalizapagotercero-lbl-fechasinitro"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {implicado && implicado.FechaSiniestroIMFormat}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["legalizapagotercero-lbl-fecharecepcarta"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {implicado && implicado.FechaEnvioCartaCobroFormat}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["legalizapagotercero-lbl-estado"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {implicado && implicado.EstadoImplicado}
                                </Form.Text>
                            </Col>

                            <Col md='3' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["legalizapagotercero-lbl-moneda"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {implicado && implicado?.GlosaMonedaRecobro}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["legalizapagotercero-lbl-montoneto"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {implicado && formatoMonto(implicado.MontoCosto)}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["legalizapagotercero-lbl-porcconvenio"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {implicado && implicado.PorConvenido}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["legalizapagotercero-lbl-montorecobro"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {implicado && formatoMonto(implicado.MontoRecobro)}
                                </Form.Text>
                            </Col>
                            <Col md='2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["legalizapagotercero-lbl-fechaaprueba"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {implicado && implicado.FechaRespuestaCartaFormat}
                                </Form.Text>
                            </Col>
                            <Col md='1'>
                                <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>{implicado?.idfolioCargaDocto ? "Ver Carta" : "No existe Carta"}</Tooltip>}>
                                    <button style={{ backgroundColor: 'white', border: 'none', marginTop: '10px' }}>
                                        <FaSearch
                                            size={20}
                                            color='gray'
                                            onClick={handleInforme}
                                        />
                                    </button>
                                </OverlayTrigger>
                            </Col>
                        </Row>
                    </Container>
                </Card.Body>
            </Card>
        </Fragment>
    )
}

export default HeaderInfo;